var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',[_c('div',{staticClass:"overlay"}),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._v("\n    "+_vm._s(_vm.t('harvester.loading'))+"\n  ")])]):_c('div',[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }